import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows } from "./section-loan-forbearance-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanForbearance extends Component {
  drawDataForbearance(data) {
    if (data.forbearance) {
      if (data.forbearance.effectiveDate ||
        data.forbearance.paymentDeferralStartDate ||
        data.forbearance.paymentDeferralEndDate ||
        data.forbearance.deferralRepaymentConditionId ||
        data.forbearance.repaymentTerm ||
        data.forbearance.covenants ||
        data.forbearance.reporting ||
        data.forbearance.depositsAndReserves ||
        data.forbearance.distributionRestrictions ||
        data.forbearance.totalDeferred ||
        data.forbearance.loanForbearanceCustom.length > 0) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Forbearance",
            key: LOAN_SECTION_KEYS.LOAN_FORBEARANCE,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.LOAN_FORBEARANCE}`),
            sections: [
              this.drawDataForbearance(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.forbearance.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
